import { render, staticRenderFns } from "./SelectBedrooms.vue?vue&type=template&id=7cece0e3&"
import script from "./SelectBedrooms.vue?vue&type=script&lang=js&"
export * from "./SelectBedrooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cece0e3')) {
      api.createRecord('7cece0e3', component.options)
    } else {
      api.reload('7cece0e3', component.options)
    }
    module.hot.accept("./SelectBedrooms.vue?vue&type=template&id=7cece0e3&", function () {
      api.rerender('7cece0e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectBedrooms.vue"
export default component.exports